import { Link } from 'react-router-dom';
import { Flame, Plus, Wallet } from 'lucide-react';
import { LoginArea } from '@/components/auth/LoginArea';
import { Button } from '@/components/ui/button';
import { WalletModal } from '@/components/WalletModal';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Navigation */}
      <nav className="border-b border-border/60 bg-card/70 backdrop-blur-md sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2 group">
              {/* Icon-style torch mark */}
              <div className="w-7 h-7 relative flex items-center justify-center">
                <Flame className="w-6 h-6 text-orange-400 group-hover:text-orange-300 transition-colors drop-shadow-[0_0_6px_rgba(251,146,60,0.6)]" />
              </div>
              <span className="text-xl font-bold tracking-tight text-foreground">
                torch<span className="text-orange-400">lite</span>
              </span>
            </Link>

            <div className="flex items-center gap-3">
              <Link to="/create">
                <Button size="sm" variant="outline" className="gap-1 border-border/60 hover:border-orange-500/50 hover:text-orange-400 transition-colors">
                  <Plus className="w-4 h-4" />
                  Light a Torch
                </Button>
              </Link>
              <div className="w-px h-4 bg-border/60" />
              <WalletModal>
                <Button size="sm" variant="ghost" className="gap-1 hover:text-orange-400">
                  <Wallet className="w-4 h-4" />
                </Button>
              </WalletModal>
              <div className="w-px h-4 bg-border/60" />
              <LoginArea className="max-w-48" />
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer */}
      <footer className="border-t border-border/60 py-6 mt-auto">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center justify-between text-sm text-muted-foreground">
            <p>
              Built with <span className="text-orange-400">🔥</span> on Nostr
            </p>
            <div className="flex items-center gap-4">
              <Link
                to="/preview"
                className="hover:text-foreground transition-colors"
              >
                How it Works
              </Link>
              <a
                href="https://shakespeare.diy"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-foreground transition-colors"
              >
                Vibed with Shakespeare
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
